import type { CmmsVendorsResponse } from "@assetwatch/marketplace-api";
import { marketplaceClient } from "./marketplaceClient";

/**
 * Read-only CMMS vendor lookup. Reuses the marketplace BFF client so auth,
 * and request IDs behave identically across the app.
 */
export async function fetchCmmsVendors(): Promise<CmmsVendorsResponse> {
  const response = await marketplaceClient.v1.cmms.vendors.$get();

  if (!response.ok) {
    throw new Error(`CMMS vendor request failed with ${response.status}`);
  }

  return response.json() as Promise<CmmsVendorsResponse>;
}
